import React, { useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Menu, X } from 'lucide-react';
type Page = 'home' | 'about' | 'services' | 'contact';
interface HeaderProps {
  onNavigate: (page: Page) => void;
  currentPage: Page;
}
export function Header({
  onNavigate,
  currentPage
}: HeaderProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  const headerBackground = useTransform(scrollY, [0, 50], ['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 0.95)']);
  const headerShadow = useTransform(scrollY, [0, 50], ['none', '0 4px 6px -1px rgba(0, 0, 0, 0.05)']);
  const navLinks = [{
    name: 'About',
    page: 'about' as Page
  }, {
    name: 'Services',
    page: 'services' as Page
  }, {
    name: 'Contact',
    page: 'contact' as Page
  }];
  const handleNavClick = (e: React.MouseEvent, page: Page) => {
    e.preventDefault();
    onNavigate(page);
    setIsMobileMenuOpen(false);
  };
  return <motion.header style={{
    backgroundColor: headerBackground,
    boxShadow: headerShadow
  }} className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 backdrop-blur-sm" data-id="element-54">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <div className="flex justify-between items-center h-20" data-id="element-56">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => onNavigate('home')} data-id="element-57">
            <img src="https://cdn.magicpatterns.com/uploads/3dSrKM3ghNM5VaqUnLUSSd/Whiterock_Partners.png" alt="Whiterock Partners" className="h-12" style={{
            imageRendering: 'auto',
            WebkitFontSmoothing: 'antialiased'
          }} data-id="element-58" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-59">
            {navLinks.map(link => <a key={link.name} href="#" onClick={e => handleNavClick(e, link.page)} className={`text-sm uppercase tracking-widest font-medium transition-colors duration-200 ${currentPage === link.page ? 'text-primary' : 'text-gray-600 hover:text-primary'}`} data-id="element-60">
                {link.name}
              </a>)}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-61">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-600 hover:text-primary focus:outline-none" data-id="element-62">
              {isMobileMenuOpen ? <X size={24} data-id="element-63" /> : <Menu size={24} data-id="element-64" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-white border-t border-gray-100" data-id="element-65">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-66">
            {navLinks.map(link => <a key={link.name} href="#" onClick={e => handleNavClick(e, link.page)} className={`block px-3 py-4 text-base font-medium uppercase tracking-wider ${currentPage === link.page ? 'text-primary bg-primary/5' : 'text-gray-600 hover:text-primary hover:bg-gray-50'}`} data-id="element-67">
                {link.name}
              </a>)}
          </div>
        </motion.div>}
    </motion.header>;
}